module.exports = __webpack_public_path__ + "img/9_46.50ef8237.png";